import {
  ChangeDetectorRef,
  Component,
  OnInit,
} from '@angular/core';
import { FormControl } from '@angular/forms';

import { tap } from 'rxjs';

import { BaseComponent } from '@rs-bank/rs-core';
import { detectChanges } from '@rs-bank/rs-rxjs-extention';

import { DevToolsService } from './dev-tools.service';
import { ProxyConfigItem } from './proxy-config-item';


@Component({
	selector: 'app-dev-tools',
	templateUrl: './dev-tools.component.html',
	styleUrls: ['./dev-tools.component.less'],
	standalone: false,
})
export class DevToolsComponent extends BaseComponent implements OnInit {


	public isExpand = false;
	public targetList: Array<ProxyConfigItem>;
	public selectControl = new FormControl();

	constructor(
		private devToolsService: DevToolsService,
		public override changeDetectorRef: ChangeDetectorRef,
	) {
		super(changeDetectorRef);
	}

	public ngOnInit(): void {
		this.selectControl.setValue(this.devToolsService.applicationApiSegment);

		this.devToolsService.getConfig()
			.pipe(
				tap((config: Array<ProxyConfigItem>) => {
					this.targetList = config;
					if (!this.selectControl.value) {
						this.selectControl.setValue(this.targetList[0]);
					}
				}),
				detectChanges(this),
			)
			.subscribe();

		this.selectControl
			.valueChanges
			.pipe(
				tap((x: ProxyConfigItem) => {
					this.devToolsService.applicationApiSegment = x;
				}),
			)
			.subscribe();
	}

	public toggle(): void {
		this.isExpand = !this.isExpand;
	}

	public compareFn(c1: ProxyConfigItem, c2: ProxyConfigItem): boolean {
		return c1 && c2 ? c1.value.target === c2.value.target : c1 === c2;
	}

	public getTarget(proxyConfigItem: ProxyConfigItem) {
		return proxyConfigItem.value['settings-for-custom-proxy'].target;
	}
}
